import React from "react";
import { setAppTeamModalOpen } from "../../../../redux/slices/appSettingsSlice";
import SelectedTeamRoleCardExtraTitle from "./SelectedTeamRoleCardExtraTitle";

const ConnectedSelectedTeamRoleCardExtraTitle = () => (
    <SelectedTeamRoleCardExtraTitle setAppTeamModalOpen={setAppTeamModalOpen} />
);

export default ConnectedSelectedTeamRoleCardExtraTitle;
